import { SxStyles } from 'src/types/theme';

const styles: SxStyles = {
  moreButton: {
    paddingTop: '5px',
    paddingBottom: '5px',
  },
};

export default styles;
